import PainelAPI from '../../api/painel';

const state = {
  records: [],
  uiFlags: { isFetching: false, isMutating: false },
};

const getters = {
  getFieldDefinitions: $state => $state.records,
  getActiveFieldDefinitions: $state =>
    $state.records.filter(r => !r.archived_at),
  getRequiredFieldDefinitions: $state =>
    $state.records.filter(r => r.required && !r.archived_at),
  getFieldDefinitionsFlags: $state => $state.uiFlags,
};

const mutations = {
  SET($state, records) {
    $state.records = [...records];
  },
  PUSH($state, record) {
    $state.records = [...$state.records, record];
  },
  PATCH($state, record) {
    $state.records = $state.records.map(r => (r.id === record.id ? record : r));
  },
  REMOVE($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
  UI($state, { flag, value }) {
    $state.uiFlags[flag] = value;
  },
};

const actions = {
  fetch: async ({ commit }) => {
    commit('UI', { flag: 'isFetching', value: true });
    try {
      const { data } = await PainelAPI.fieldDefinitions();
      commit('SET', data.payload || []);
    } finally {
      commit('UI', { flag: 'isFetching', value: false });
    }
  },
  create: async ({ commit }, payload) => {
    const { data } = await PainelAPI.createFieldDefinition(payload);
    commit('PUSH', data.payload);
    return data.payload;
  },
  update: async ({ commit }, { id, payload }) => {
    const { data } = await PainelAPI.updateFieldDefinition(id, payload);
    commit('PATCH', data.payload);
    return data.payload;
  },
  remove: async ({ commit }, id) => {
    await PainelAPI.deleteFieldDefinition(id);
    commit('REMOVE', id);
  },
  reorder: async ({ commit, state: _state }, ids) => {
    const previous = _state.records;
    const reordered = ids
      .map((id, idx) => {
        const record = previous.find(r => r.id === id);
        return record ? { ...record, position: idx + 1 } : null;
      })
      .filter(Boolean);
    commit('SET', reordered);
    try {
      await PainelAPI.reorderFieldDefinitions(ids);
    } catch (err) {
      commit('SET', previous);
      throw err;
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
